import React from "react";
import { useState, useEffect } from "react";
import SideBar from "../../SideBar";
import Swal from "sweetalert2";
import HeaderName from "../../HeaderName";
import FileUploadHandler from "../../../../features/fileUploader";
import { api } from "../../../../api/api";

function ShopInfo() {
  const [shopInfo, setShopInfo] = useState({
    shopName: "",
    shopAddress: "",
    shopEmail: "",
    shopPhone: "",
    image: null,
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setShopInfo({
      ...shopInfo,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (file) => {
    setShopInfo((prev) => ({ ...prev, image: file }));
  };

  const updateShopInfo = async (e, shopId) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("shopName", shopInfo.shopName);
      formData.append("shopAddress", shopInfo.shopAddress);
      formData.append("shopEmail", shopInfo.shopEmail);
      formData.append("shopPhone", shopInfo.shopPhone);
      if (!shopInfo.image) {
        formData.append("mainImgURL", shopInfo.mainImgURL);
      }
      formData.append("files", shopInfo.image);
      const res = await api.put(`shop-info/${shopId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setShopInfo(res.data.shopInfo);
      Swal.fire({
        title: "Successful!",
        text: "Successfully Updated!",
        icon: "success",
        showCancelButton: false,
        timer: 3000,
      });
    } catch (err) {
      Swal.fire({
        title: "Something Wrong!",
        text: "Try again, Please.",
        icon: "warning",
        showCancelButton: false,
        timer: 3000,
      });
    } finally {
      setLoading(false);
      setIsUpdate(false);
    }
  };

  useEffect(() => {
    const getShopInfo = async () => {
      try {
        const res = await api.get("shop-infos");
        setShopInfo(res.data.data[0]);
      } catch (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          showCancelButton: false,
          timer: 3000,
        });
      }
    };
    getShopInfo();
  }, []);
  return (
    <>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active fs-5">Shop Info List</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Main content --> */}

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-8 offset-2">
              <div className="card">
                <h5 className="card-header mb-4 fw-5 text-secondary py-3 d-flex justify-content-between">
                  <span>Shop Info</span>
                  <div class="form-check form-switch ms-auto">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      checked={isUpdate}
                      onChange={() => setIsUpdate(!isUpdate)}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    <label
                      class="form-check-label cursor"
                      for="flexSwitchCheckDefault"
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      Update
                    </label>
                  </div>
                </h5>
                <div className="px-3 py-3">
                  <div class="form-group">
                    <label for="code" className="text-secondary">
                      Shop Name
                    </label>
                    <input
                      type="text"
                      class="form-control border-info"
                      name="shopName"
                      id="shopName"
                      value={shopInfo?.shopName}
                      onChange={handleChange}
                      disabled={!isUpdate}
                    />
                  </div>

                  <div class="form-group">
                    <label for="code" className="text-secondary">
                      Email
                    </label>
                    <input
                      type="email"
                      class="form-control border-info"
                      name="shopEmail"
                      id="shopEmail"
                      value={shopInfo?.shopEmail}
                      onChange={handleChange}
                      disabled={!isUpdate}
                    />
                  </div>

                  <div class="form-group">
                    <label for="code" className="text-secondary">
                      Phone
                    </label>
                    <input
                      type="text"
                      class="form-control border-info"
                      name="shopPhone"
                      id="shopPhone"
                      value={shopInfo.shopPhone}
                      onChange={handleChange}
                      disabled={!isUpdate}
                    />
                  </div>
                  <div class="form-group">
                    <label for="level" className="text-secondary">
                      Address
                    </label>
                    <input
                      type="text"
                      class="form-control border-info"
                      name="shopAddress"
                      id="shopAddress"
                      value={shopInfo?.shopAddress}
                      onChange={handleChange}
                      disabled={!isUpdate}
                    />
                  </div>

                  <div className="py-2">
                    <label for="name">Main Image</label>
                    <FileUploadHandler
                      handleChange={handleFileChange}
                      defaultImage={shopInfo?.mainImgURL}
                      attribute={{ disabled: !isUpdate }}
                    />
                  </div>
                  {isUpdate && (
                    <button
                      style={{ backgroundColor: "#0b9490", color: "white" }}
                      className="btn  form-control text-center fw-5"
                      onClick={(e) => {
                        updateShopInfo(e, shopInfo._id);
                      }}
                      disabled={loading}
                    >
                      {loading && (
                        <span className=" spinner-border spinner-border-sm me-2"></span>
                      )}
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default ShopInfo;
